import { connect } from 'react-redux'
import { setPrecedentAdminParentId } from 'redux/actions'
import SubSection from 'pages/documentscontent/precedentsadmin/SubSection'

const mapStateToProps = state => ({
  parentId: state.precedents.admin.parentId,
  expandedSection: state.precedents.expandedSection
})

const mapDispatchToProps = dispatch => ({
  setParentId: parentId => dispatch(setPrecedentAdminParentId(parentId))
})

export default connect(mapStateToProps, mapDispatchToProps)(SubSection)
